module.exports = __webpack_public_path__ + "static/media/eye-black-outline.f71e5a65.svg";